import { createContext, Dispatch, SetStateAction, useContext } from 'react'

type SearchContext = [string, Dispatch<SetStateAction<string>>]

export const SearchContext = createContext<SearchContext>(['', () => {}])

export const useSearch = () => {
  return useContext(SearchContext)
}
